import LearnPageLayout from "@/components/LearnPageLayout";
import { pageFmriGuided } from "./learnDataFmriGuided";

const FmriGuidedPage = () => (
  <LearnPageLayout
    title={pageFmriGuided.title}
    description={pageFmriGuided.description}
    canonical={pageFmriGuided.canonical}
    h1={pageFmriGuided.h1}
    breadcrumbLabel={pageFmriGuided.breadcrumbLabel}
    crumbs={pageFmriGuided.crumbs}
    shortAnswer={pageFmriGuided.shortAnswer}
    keyTakeaways={pageFmriGuided.keyTakeaways}
    sections={pageFmriGuided.sections}
    faqs={pageFmriGuided.faqs}
    sources={pageFmriGuided.sources}
    schemaJson={pageFmriGuided.schemaJson}
    relatedLinks={pageFmriGuided.relatedLinks}
    reviewBlock={pageFmriGuided.reviewBlock}
  />
);

export default FmriGuidedPage;
